import React, { createContext, useContext, useState, useCallback } from "react";



const LoadingContext = createContext({
  loading: false,
  setLoading: () => {},
});



export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const setLoadingSafe = useCallback((val) => setLoading(!!val), []);
  return (
    <LoadingContext.Provider value={{ loading, setLoading: setLoadingSafe }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  return useContext(LoadingContext);
}
